import React from "react";
import styles from './StepBar.module.scss';

interface StepBarProps {
  currentStep: number;
  stepData?: string[];
}

const StepBar: React.FC<StepBarProps> = ({ currentStep, stepData }) => {
  const defaultStepData = [
    "When A Buyer Applies For A Refund",
    "Sellers Handle Refund Requests",
    "The Refund Has Been Completed",
  ];
  const steps = stepData || defaultStepData;
  return (
      <div className={styles['refund-flow']}>
        {steps.map((text, index) => {
          const isFirst = index === 0;
          const isLast = index === steps.length - 1;
          const isActive = index === currentStep - 1;
          const isCompleted = index < currentStep - 1;

          const stepItemClass = `${styles['step-item']} ${
            isFirst ? styles['first'] : isLast ? styles['last'] : styles['middle']
          } ${
            isActive ? styles['active'] : isCompleted ? styles['completed'] : styles['inactive']
          }`;

          const stepNumberClass = `${styles['step-number']} ${
            isActive ? styles['active'] : styles['inactive']
          }`;

          return (
            <div key={index} className={stepItemClass}>
              <div className={stepNumberClass}>
                {index + 1}
              </div>
              <span>{text}</span>
            </div>
          );
        })}
      </div>
  );
};

export default StepBar;
